import messages from '../intl/index.js';
import dropdownStyles from './Dropdown.module.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useMessageFormatter } from '../../i18n/format.js';
import { Text } from '../../text/Text.js';
import { Button } from '../../button/Button.js';

function NoData(props) {
  const {
    loadingState,
    onSearch,
    search
  } = props;
  const {
    formatMessage,
    formatReactMessage
  } = useMessageFormatter(messages);
  switch (loadingState) {
    case 'loading':
      return /*#__PURE__*/jsx("div", {
        className: dropdownStyles['no-data'],
        children: /*#__PURE__*/jsx(Text, {
          children: search ? formatReactMessage('Searching for <q>{search}</q>', {
            search,
            q: chunk => /*#__PURE__*/jsx("q", {
              children: chunk
            }, chunk.join())
          }) : formatMessage('Searching...')
        })
      });
    case 'failure':
      return /*#__PURE__*/jsxs("div", {
        className: dropdownStyles['no-data'],
        children: [/*#__PURE__*/jsx(Text, {
          children: formatMessage('There was a problem completing your search')
        }), /*#__PURE__*/jsx(Button, {
          size: "small",
          onClick: () => onSearch?.(search),
          children: formatMessage('Try again')
        })]
      });
    default:
      if (search) {
        return /*#__PURE__*/jsx("div", {
          className: dropdownStyles['no-data'],
          children: /*#__PURE__*/jsx(Text, {
            children: formatReactMessage('No results for <q>{search}</q>', {
              search,
              q: chunk => /*#__PURE__*/jsx("q", {
                children: chunk
              })
            })
          })
        });
      } else {
        return /*#__PURE__*/jsx("div", {
          className: dropdownStyles['no-data'],
          children: /*#__PURE__*/jsx(Text, {
            children: search ? formatReactMessage('No results for <q>{search}</q>', {
              search,
              q: chunk => /*#__PURE__*/jsx("q", {
                children: chunk
              })
            }) : formatMessage('No results')
          })
        });
      }
  }
}

export { NoData };
